import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
};

const DesignEditorControls = ({ className, children }) => {
  const classes = classNames({
    'design-editor-controls': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditorControls.propTypes = propTypes;

export default DesignEditorControls;
